<template>
  <CommonPanel title="本月销售排行" :needExtra="true">
    <a-button type="primary" size="small" slot="extra" class="export-btn" @click="downloadRankData">导出</a-button>
    <a-tabs default-active-key="0" :animated="false">
      <a-tab-pane key="0" tab="品牌">
        <a-table :columns="seriesColumns" :data-source="series" :pagination="false" size="middle" :scroll="{y: 167}" rowKey="code" />
      </a-tab-pane>
      <a-tab-pane key="1" tab="单品">
        <a-table :columns="spuColumns" :data-source="spu" :pagination="false" size="middle" :scroll="{y: 167}" rowKey="code" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="分部">
        <a-table :columns="branchColumns" :data-source="branch" :pagination="false" size="middle" :scroll="{y: 167}" rowKey="code" />
      </a-tab-pane>
      <div slot="tabBarExtraContent" class="order">
        <label>{{orderTypeDesc}}</label>
        <img :src="require('@/assets/images/icon-order.png')" @click="sortRankData" />
      </div>
    </a-tabs>
  </CommonPanel>
</template>
<script>
  import CommonPanel from "@/components/common-panel/index"
  import { Button, Tabs, Table } from 'ant-design-vue'
  import _ from 'lodash'
  const { TabPane } = Tabs
  export default {
    name: 'sales-rank',
    components: {
      CommonPanel,
      [Button.name]: Button,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Table.name]: Table,
    },
    data() {
      return {
        orderType: 'dc',
        orderTypeDesc: '从高到低排序',
        branch: [], // 分部
        series: [], // 品牌
        spu: [], // 单品
        branchColumns: [
          {
            title: '综合排名',
            dataIndex: 'rank',
            align: 'center',
            width: '25%'
          },
          {
            title: '分部',
            dataIndex: 'name',
            align: 'center',
            width: '25%'
          },
          {
            title: '本月销售额(元)',
            dataIndex: 'salesAmount',
            align: 'center',
            width: '25%'
          },
          {
            title: '本月销量(单)',
            dataIndex: 'salesNum',
            align: 'center',
            width: '25%'
          }
        ],
        spuColumns: [
          {
            title: '综合排名',
            dataIndex: 'rank',
            align: 'center',
            width: '25%'
          },
          {
            title: '单品',
            dataIndex: 'name',
            align: 'center',
            width: '25%'
          },
          {
            title: '本月销售额(元)',
            dataIndex: 'salesAmount',
            align: 'center',
            width: '25%'
          },
          {
            title: '本月销量(单)',
            dataIndex: 'salesNum',
            align: 'center',
            width: '25%'
          }
        ],
        seriesColumns: [
          {
            title: '综合排名',
            dataIndex: 'rank',
            align: 'center',
            width: '25%'
          },
          {
            title: '品牌',
            dataIndex: 'name',
            align: 'center',
            width: '25%'
          },
          {
            title: '本月销售额(元)',
            dataIndex: 'salesAmount',
            align: 'center',
            width: '25%'
          },
          {
            title: '本月销量(单)',
            dataIndex: 'salesNum',
            align: 'center',
            width: '25%'
          }
        ]
      }
    },
    created() {
      this.getRankData()
    },
    methods: {
      sortRankData() {
        if(this.orderType === 'dc') {
          this.orderType = 'ac'
          this.orderTypeDesc = '从低到高排序'
        } else {
          this.orderType = 'dc'
          this.orderTypeDesc = '从高到低排序'
        }
        this.getRankData()
      },
      downloadRankData() {
        this.$store.dispatch('brandHome/downloadRankData', this.orderType)
      },
      async getRankData() {
        const res = await this.$store.dispatch('brandHome/queryRankData', this.orderType)
        if(res && +res.code === 0 && res.data) {
          this.branch = _.get(res.data, 'branch') || []
          this.series = _.get(res.data, 'series') || []
          this.spu = _.get(res.data, 'sPU') || []
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .export-btn {
    width: 90px;
    height: 28px;
  }
  .order {
    display: flex;
    align-items: center;
    label {
      font-size: 14px;
      color: #666;
    }
    img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
  }
</style>
